import { a as U } from "../add-DH4DZT_w.mjs";
import { f as Y } from "../format-DF9p-6BI.mjs";
import { getCurrentEasternProgrammingDateStr as V, determineIfShowIsOnNow as Z } from "./date-helpers.js";
import { convert12to24 as d } from "./helpers.js";
import { determineSeriesPrefix as B, determineSeasonNumberFromSeriesPrefix as D, determineEpisodeNumber as G } from "./series-helpers.js";
import { g as J } from "../index-0wieGV50.mjs";
const H = /* @__PURE__ */ new Date(`${V()}T00:00:00`), Q = (o) => {
  const n = o.substring(0, o.lastIndexOf("S") - 1);
  return n === "" ? o : n;
}, W = async ({ scheduleEndpoint: o, network: n }) => {
  let i = [], m = {}, s = 0, l = "";
  const c = Y(H, "yyyy-MM-dd"), u = Y(U(H, { days: 2 }), "yyyy-MM-dd");
  do {
    l = `${o}/${n}?ordering=start_ts_parse&start_date__range=${c},${u}&limit=100&offset=${s}`;
    try {
      const a = await fetch(l);
      if (a != null && a.ok)
        m = await a.json(), i = [...i, ...m.results];
      else {
        console.error(`An error was returned from fetch. HTTP Response Code: ', ${a == null ? void 0 : a.status}`);
        break;
      }
    } catch (a) {
      console.error("Fetch failed with error:", a);
      break;
    }
    s += 100;
  } while (m.next !== null);
  return { results: i };
}, K = async ({ seriesPrefix: o, getResource: n, resourceName: i = "onnow" }) => {
  var s;
  return await ((s = (await n({
    queryKey: [
      "",
      {
        resourceName: i,
        queryVars: {
          id: `seriesPrefix = ${o}`
        }
      }
    ]
  })).SeriesList) == null ? void 0 : s.items[0]);
}, X = async (o) => {
  var p, w, y, h, $, N, b, S, P, I, O, T, k, v, x, E, C, M, z, A, F, R, j, q;
  const {
    showEpisodeNumber: n,
    scheduleEndpoint: i,
    network: m,
    fallbackImage: s,
    getResource: l
  } = o;
  let c = "on-now";
  const u = await W({ scheduleEndpoint: i, network: m }), a = /* @__PURE__ */ new Date(), _ = u.results.filter((t) => t.program_class !== null);
  let r = await _.find((t) => Z(`${t.start_date_parse}T${d(t.start_time)}`, t.element_length));
  if (r || (r = _.find((t) => {
    const f = J("America/New_York", /* @__PURE__ */ new Date(`${t.start_date_parse}T${d(t.start_time)}`)) / 36e5;
    return (/* @__PURE__ */ new Date(`${t.start_date_parse}T${d(t.start_time)}:00-0${f * -1}:00`)).valueOf() > a;
  }), c = "upcoming"), r === void 0) {
    console.error("No program found for today");
    return;
  }
  if (r.program_class === "Episode") {
    const t = B(r.series_prefix), f = n ? D(r) : null, L = n ? G(r) : null;
    let e = await K({ seriesPrefix: t, getResource: l });
    return e === void 0 && (e = await K({ seriesPrefix: t, getResource: l, resourceName: "onnowinactive" })), e === void 0 && console.warn(`No series data found for seriesPrefix: ${t}`), {
      program: {
        program_class: r.program_class,
        episode: {
          series: {
            logo: {
              black: {
                url: (w = (p = e == null ? void 0 : e.logoImage) == null ? void 0 : p.image) == null ? void 0 : w.publicUrl
              },
              dimensions: e ? ((h = (y = e.logoImage) == null ? void 0 : y.image) == null ? void 0 : h.width) / ((N = ($ = e.logoImage) == null ? void 0 : $.image) == null ? void 0 : N.height) : 1,
              aspect_ratio: e ? ((S = (b = e.logoImage) == null ? void 0 : b.image) == null ? void 0 : S.width) / ((I = (P = e.logoImage) == null ? void 0 : P.image) == null ? void 0 : I.height) : 1
            },
            image: {
              url: ((O = r.content) == null ? void 0 : O.image) === "" ? s.url : (T = r.content) == null ? void 0 : T.image,
              sizes: e ? (E = (x = (v = (k = e == null ? void 0 : e.items) == null ? void 0 : k[0]) == null ? void 0 : v.nowPlayingImage) == null ? void 0 : x.image) == null ? void 0 : E.sizes : void 0
            },
            primary_color: ((z = (M = (C = e == null ? void 0 : e.colors) == null ? void 0 : C.entries) == null ? void 0 : M.find((g) => g.key === "primaryColor")) == null ? void 0 : z.value) ?? "var(--theme-color-400)",
            secondary_color: ((R = (F = (A = e == null ? void 0 : e.colors) == null ? void 0 : A.entries) == null ? void 0 : F.find((g) => g.key === "secondaryColor")) == null ? void 0 : R.value) ?? "var(--theme-color-400)",
            slug: (e == null ? void 0 : e.slug) ?? null,
            name: (e == null ? void 0 : e.title) ?? Q(r.program)
          },
          season: f,
          number: L,
          name: r.title_name
        },
        airdate: `${r.start_date} ${d(r.start_time)}`
      },
      type: c
    };
  }
  if (r.program_class === "Film" || r.program_class === "Sports" || r.program_class === "Special")
    return {
      program: {
        program_class: r.program_class,
        name: r.title_name,
        primary_color: "var(--theme-color-100)",
        secondary_color: "var(--theme-color-200)",
        airdate: `${r.start_date} ${d(r.start_time)}`,
        episode: {
          series: {
            image: {
              url: ((j = r.content) == null ? void 0 : j.image) === "" ? s.url : (q = r.content) == null ? void 0 : q.image
            }
          }
        }
      },
      type: c
    };
}, se = async (o = { showEpisodeNumber: !1 }) => await X(o);
export {
  se as getOnNowProgram
};
